import { Component, Inject, OnInit } from '@angular/core';
import { OktaAuth ,AuthState} from '@okta/okta-auth-js';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { Router } from '@angular/router';
import { filter,  map, Observable } from 'rxjs';
import { UserProfileService } from '../../services/user-profileinfo/user-profile.service';
import { login } from '../../constants/core.constant';
import { HeaderService } from '../../services/header/header.service';
import { UserService } from '../../services/user-service/user-service.service';
import { SettingsService } from 'src/app/shared/services/settings/settings.service';
import { BaseApiService } from 'src/app/shared/services/base-api/base-api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public isAuthenticated$!: Observable<boolean>;
  public name$!: Observable<string>;
  public token$!: Observable<string>;
  logininfo = login;
  clearCache: any;
  userDetails = JSON.parse(localStorage.getItem('user-profile'));
  name: string;
  profileSubscription: any;
  profile: any;
  permissionsData: any;
  profileData: any;
  roles: any;
  userTypeId: any;
  userClaims: any;

  constructor(
    @Inject(OKTA_AUTH) private readonly _oktaAuth: OktaAuth,
    private readonly _oktaStateService: OktaAuthStateService,
    private readonly router: Router,
    private readonly userProfile: UserProfileService,
    private readonly userService: UserService,
    private readonly profileService: SettingsService,
    private readonly headerService: HeaderService,
    private readonly baseService: BaseApiService
  ) { }

  userInfo: any;

  ngOnInit(): void {
    this.isAuthenticated$ = this._oktaStateService.authState$.pipe(
      filter((s: AuthState) => !!s),
      map((s: AuthState) => s.isAuthenticated ?? false)
    );
    this.userDetails = JSON.parse(localStorage.getItem('user-profile'));
    if (this.userDetails) {
      this.permissionsData = { ...this.userDetails.roleAssigned };
      this.userTypeId = this.userDetails?.userTypeId
    }
    this.getUserInfo();
    this.changeUserName();
    this.updateName()
  }

  /**
   *logout() - after successfull logout this method will redirect to signed out dashboard
   */
  async logout(): Promise<any> {
    await this.headerService.clearCache().subscribe({
      next: (data: any) => {
        this.clearCache = data.message;
      },
      error: (error: any) => { },
    });
    await this._oktaAuth.signOut();
    localStorage.clear();

    // Notify other opened tabs to redirect to home page during logout.
    localStorage.setItem('logout-event', Date.now().toString());
    this._oktaAuth.tokenManager.clear();
    localStorage.removeItem('access-token');
    localStorage.removeItem('okta-token-storage');
    
  }

  /**
   * callOktaLogoutSession() - method to kill the okta user session
   * @param url logout session okta url
   */
  callOktaLogoutSession(url: string): void {
    this.baseService.logout(url).pipe()
      .subscribe({
        next: () => {
          console.info('Logout successfully');
        },
        error: (error) => {
          console.error('Error in Logout URL:', error);
        }
      });
  }

  /**
   * oktaAuthentication() - after successful login this method will redirect to respective dashboard
   */
  async oktaAuthentication(): Promise<void> {
    // Do NOT navigate to homepage here; Okta will handle the redirect
    await this._oktaAuth
      .signInWithRedirect().catch((Error) => {
        // Optionally handle error
        console.error('Okta signInWithRedirect error:', Error);
      });
  }

  /**
   *loginUser() - invoke the OKTA login method
   */
  loginUser(): void {
    // Clear all localStorage before login
    localStorage.removeItem('okta-cache-storage');
    localStorage.removeItem('okta-original-uri-storage');
    localStorage.removeItem('okta-token-storage');
    localStorage.removeItem('okta-shared-transaction-storage');
    localStorage.removeItem('logout-event');
    localStorage.removeItem('user-profile');
    // Start Okta login
    this.oktaAuthentication();
  }

  /**
   *getuserProfileinfo() - Method to get user information via API
   */
  getuserProfileinfo(): void {
    this.userProfile.getUsers().subscribe((posts) => {
      localStorage.setItem('user-profile', JSON.stringify(posts));
    });
    this.userInfo = JSON.parse(localStorage.getItem('user-profile'));
  }

  /**
   * getUserInfo() - used to subscribe userInfo that is set from the service
   */
  getUserInfo(): void {
    this.userService.userInfo$.subscribe((userInfo) => {
      if (userInfo) {
        this.userDetails = userInfo?.userProfileDTO;
        this.userTypeId = this.userDetails?.userTypeId;
        this.roles = userInfo
        this.name = this.userDetails?.firstName + ' ' + this.userDetails?.lastName;
        this.permissionsData = { ...this.userDetails?.roleAssigned };
      }
    });
  }

  /**
   * changeUserName() - to change full name when user updates his name
   */
  changeUserName(): void {
    this.profileSubscription = this.profileService.profile$.subscribe(
      (profile) => {
        if (profile) {
          this.profile = profile;
          this.name = `${this.profile?.userProfileSearch?.firstName} ${this.profile?.userProfileSearch?.lastName}`;
        }
      }
    );
  }

  /**
   * updateName() - to update the name
   */
  updateName(): void {
    const updatedDetails = JSON.parse(localStorage.getItem('updated-profile'))
    if (updatedDetails) {
      this.name = updatedDetails?.firstName + ' ' + this.userDetails?.lastName;
    }
    else if (this.userDetails) {
      this.name = this.userDetails?.firstName + ' ' + this.userDetails?.lastName;
    }
  }

  /**
   * redirectToProfile() - Redirects the user to the appropriate profile page based on their user type.
   *
   */
  redirectToProfile(): void {
    if (this.userDetails?.userTypeId === 1) {
      this.router.navigate(['feature/customer-dashboard/user-dropdown']);
    } else {
      this.router.navigate(['feature/studio-dashboard/user-dropdown']);
    }
  }

/**
 * navigateToRegister -Navigates to register component.
 */
  navigateToRegister(): void{
    this.router.navigate(['register']);
  }
}
